import { AppProviders } from "@/app/providers";
import { AppRouter } from "@/app/router";
import { useKeycloakInit } from "@/core/auth";
import { LoadScreen, LoadScreenError } from "@/core/components/shared";
import { useVersionCheck } from "@/core/hooks/use-version-check";
import { useFcmNotifications } from "@/core/notifications/use-fcm";

function VersionWatcher() {
  useVersionCheck();
  return null;
}

/** Notifications push FCM — auto-gâté par la session (accessToken). */
function FcmWatcher() {
  useFcmNotifications();
  return null;
}

export default function App() {
  // Init Keycloak avant tout rendu du router : les gardes de routes
  // (RequireAuth) lisent keycloak.authenticated, fiable seulement une fois
  // l'init terminée. LoadScreen pendant l'attente (règle loaders).
  const { status } = useKeycloakInit();

  if (status === "error") {
    return (
      <div className="h-screen">
        <LoadScreenError />
      </div>
    );
  }

  if (status === "loading") {
    return (
      <div className="flex h-screen items-center justify-center bg-background">
        <LoadScreen />
      </div>
    );
  }

  return (
    <AppProviders>
      <VersionWatcher />
      <FcmWatcher />
      <AppRouter />
    </AppProviders>
  );
}
